import {
  BottomSheet,
  CloseIcon,
  GridIcon,
  HamburgerIcon,
  IconButton,
} from "@songtradr-one/components-frontend";
import { NotificationsPanelMobile } from "@songtradr-one/notifications-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import { ControlCenter } from "../../shared/components/control-center/ControlCenter";
import {
  MobileGridIconSpacer,
  NavBar,
  text,
  useAppHeader,
} from "./AppHeader.Parts";
import { Branding } from "./branding/Branding";
import { CustomerSupportMobile } from "./customer-support/CustomerSupport.Mobile";
import { UserMenuMobile } from "./user-menu/UserMenu.Mobile";

export const AppHeaderMobile = () => {
  const {
    userMenuOpen,
    controlCenterOpen,
    isHome,
    subModules,
    setShowUserMenu,
    setControlCenterOpen,
    toggleControlCenter,
    toggleUserMenu,
    navigate,
    location,
  } = useAppHeader();

  return (
    <>
      <CustomerSupportMobile onOpenChange={() => navigate(location.pathname)} />
      <UserMenuMobile
        open={userMenuOpen}
        onOpenChange={setShowUserMenu}
        subModules={subModules}
      />
      <BottomSheet
        open={controlCenterOpen}
        onOpenChange={setControlCenterOpen}
        hiddenTitle={text.controlCenter.title}
      >
        <ControlCenter />
      </BottomSheet>

      <NavBar>
        {userMenuOpen ? (
          <IconButton
            onClick={toggleUserMenu}
            aria-expanded={userMenuOpen}
            $small
          >
            <CloseIcon />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => {
              toggleUserMenu();
              if (controlCenterOpen) toggleControlCenter();
            }}
            aria-expanded={userMenuOpen}
            $small
          >
            <HamburgerIcon />
          </IconButton>
        )}
        <Branding />
        <Flex $align="center" $justify="flex-end" $gap="0.25rem" $wrap="nowrap">
          <NotificationsPanelMobile />
          {!isHome ? (
            controlCenterOpen ? (
              <IconButton
                onClick={toggleControlCenter}
                aria-expanded={controlCenterOpen}
                $small
              >
                <CloseIcon />
              </IconButton>
            ) : (
              <IconButton
                $active={controlCenterOpen}
                onClick={() => {
                  toggleControlCenter();
                  if (userMenuOpen) toggleUserMenu();
                }}
                aria-expanded={controlCenterOpen}
                $small
              >
                <GridIcon height="1rem" />
              </IconButton>
            )
          ) : (
            <MobileGridIconSpacer />
          )}
        </Flex>
      </NavBar>
    </>
  );
};
